import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p424248449896124416',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
